/**
 * Priority countries for phone codes that are used by multiple countries
 * Key - dialCode (without +), value - iso2 of the priority country
 */
const priorityCountries = {
    // +1 - North American Numbering Plan (USA, Canada, and Caribbean countries)
    // Priority: USA (largest country by population in this zone)
    1: "us",
    // +7 - Russia and Kazakhstan
    // Priority: Russia
    7: "ru",

    // +44 - United Kingdom and other territories
    // Priority: United Kingdom
    44: "gb",

    // +61 - Australia, Christmas Island, Cocos Islands
    // Priority: Australia
    61: "au",

    // +212 - Morocco and Western Sahara
    // Priority: Morocco
    212: "ma",

    // +262 - Réunion and Mayotte
    // Priority: Réunion
    262: "re",

    // +358 - Finland and Åland Islands
    // Priority: Finland
    358: "fi",

    // +590 - Guadeloupe, Saint Barthélemy, Saint Martin
    // Priority: Guadeloupe
    590: "gp",

    // +599 - Caribbean Netherlands and Curaçao
    // Priority: Curaçao (larger territory)
    599: "cw"
}

export default priorityCountries
